import React, {useEffect, useState} from 'react';
import {Autocomplete, CircularProgress, IconButton, TextField} from '@mui/material';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import AppNotificationContent from './AppNotificationContent';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import SosIcon from '@mui/icons-material/Sos';
import AppTooltip from '../AppTooltip';
import {alpha} from '@mui/material/styles';
import axios from 'axios';
import Api from '@api';
import { abortInFlightRequests } from '@common/inflightControl';
import SOSPopup from '../../../pages/SOSPOPUP/SOSPopup';
import {useDispatch, useSelector} from 'react-redux';
import {sosClicked} from 'redux/actions';
import {useAuthUser} from '@crema/utility/AuthHooks';
import TimeToLeaveIcon from '@mui/icons-material/TimeToLeave';
import {useNavigate} from 'react-router-dom';
import RoomIcon from '@mui/icons-material/Room';
import Avatar from '@mui/material/Avatar';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { getAuthenticatedImageUrl } from '@common/useAuthenticatedImage';

const AppNotifications = ({
  drawerPosition,
  tooltipPosition,
  isMenu,
  sxNotificationContentStyle,
}) => {
  const {user} = useAuthUser();
  const [sosList, setsosList] = useState();
  const [isFemale, setIsFemale] = useState(false);
  const [sosLoading, setSosLoading] = useState(false);
  const clickedSOS = useSelector(({settings}) => settings.clickedSOS);
  const dispatch = useDispatch();
  const [corporateList, setCorporateList] = React.useState([]);
  const [corpVal, setCorpVal] = React.useState(null);
  const [address, setAddress] = React.useState('');
  const navigate = useNavigate();

  let cancelCorpSwitch;

  function saveNewCorp(val, img) {

    if (cancelCorpSwitch) {
      cancelCorpSwitch("Previous switch request canceled");
    }

    // Abort every in-flight axios request before issuing the switch. The
    // server invalidates the old auth token at switch time, so any request
    // already in flight with the old token would 401 → trigger logout via the
    // response interceptor. Cancelling them avoids that race.
    abortInFlightRequests('corporate context switch');

    let postData = {
      authToken: localStorage.getItem('token'),
      userRole: 'CORPORATEADMIN',
      corporateId: val,
      tanentId: user?.userList?.tanentId,
      tanentName: user?.userList?.tanentName,
      tenentCode: user?.userList?.tenentCode,
      isImpersonate: 'TANENT',
    };
    axios
      .post(Api.baseUri + '/userauth/switchUserRoleTest1', postData, {
        cancelToken: new axios.CancelToken(function executor(c) {
          cancelCorpSwitch = c;
        }),
      })
      .then((res) => {
        if (res?.data?.status === 200) {
          const newAuthToken = res?.data?.data?.authToken;
          const newRefreshToken = res?.data?.data?.refreshToken;
          // Apply the new token to axios defaults BEFORE updating localStorage
          // so any concurrent in-flight or freshly-fired request uses the new
          // token. Without this, the old token (still in axios.defaults) hits
          // the server after the switch has invalidated it, the response
          // interceptor sees a 401, refresh fails, and the user is logged out.
          if (newAuthToken) {
            axios.defaults.headers['vtt_user_signature'] = newAuthToken;
            axios.defaults.headers.common['vtt_user_signature'] = newAuthToken;
          }
          localStorage.setItem('token', newAuthToken);
          localStorage.setItem('refresh-token', newRefreshToken);
          localStorage.setItem('COMPANY_LOGO', img);
          window.location.reload();
        }
      })
      .catch((err) => {
        if (axios.isCancel(err)) {
          console.log("Request canceled:", err.message);
        } else {
          console.error("err:", err);
        }
      });
  }
  React.useEffect(() => {
    if (user?.userList?.corporateId && corporateList?.length) {
      corporateList?.map((el) => {
        if (el.value == user?.userList?.corporateId) {
          setCorpVal(el);
        }
      });
    }
  }, [user, corporateList]);
  React.useEffect(() => {
    const getCorporateAddress = () => {
      axios
        .get(
          Api?.baseUri +
            `/user-reg/corporate-reg/${user?.userList?.corporateId}`,
        )
        .then((res) => {
          if(res?.data?.data?.siteOfficeDto) {
            setAddress(res?.data?.data?.siteOfficeDto)
          } else {
            setAddress(res?.data?.data?.siteOfficeDtos[0])
          }
        })
        .catch((err) => {});
    };

    if (user?.userList?.corporateId) getCorporateAddress();
  }, [user?.userList?.corporateId]);

  React.useEffect(() => {
    if (user?.userList?.tanentId) {
      axios
        .get(
          `${Api.baseUri}/user-reg/corporate-reg/getCorporateByTanentId/${user?.userList?.tanentId}`,
        )
        .then((response) => {
          let array = [];
          response?.data?.data?.map((el, ind) => {

            let addressName = el?.companyAddress?.addressName;
            if (addressName === 'undefined++undefined' || addressName === 'NA') {
              addressName = '';
            }
            const city = el?.companyAddress?.city;
            const corporateName = el?.siteOfficeDto?.officeName || el?.companyName
            const title2 = addressName
              ? `${corporateName} - ${addressName.split(',')[0]}, ${
                  addressName.split(',')[1]
                }, ${city}`
              : `${corporateName} - ${city}`;
              const authenticatedImageUrl = getAuthenticatedImageUrl(el?.companyRegDoc);
              if(el?.status !== 'INACTIVE') {
                array.push({
                  title: title2,
                  title2: title2,
                  value: el?.id,
                  imgsrc: authenticatedImageUrl,
                });
              }
          });
          if (array?.length && !user?.userList?.corporateId){
            setTimeout(() => {
              saveNewCorp(array[0]?.value, array[0]?.imgsrc);
            }, 1000);
          }
          setCorporateList(array);
        })
        .catch((err) => {
          setCorporateList([]);
        });
    }
  }, [user?.userList?.tanentId]);

  useEffect(() => {
    if (clickedSOS) {
      getSSOPassengers();
    }
  }, [clickedSOS]);

  // const getSSOPassengers = () => {
  //   axios
  //     .get(Api?.baseUri + '/user-reg/trip-route/get-all-sso-passenger')
  //     .then((res) => {
  //       let tem_isFemale = false;
  //       res?.data?.data?.map((el) => {
  //         if (el?.gender?.toUpperCase() == 'FEMALE') {
  //           tem_isFemale = true;
  //         }
  //       });
  //       setIsFemale(tem_isFemale);
  //       setsosList(res?.data?.data);
  //     })
  //     .catch((err) => {});
  // };

  const getSSOPassengers = () => {
    setSosLoading(true);
    const firstApi = axios.get(
      Api?.baseUri + '/user-reg/trip-route/get-all-sso-passenger',
    );
    const secondApi = axios.get(
      Api?.baseUri + '/user-reg/trip-route/get-all-sos-driver',
    ); // assuming localhost is your host

    axios
      .all([firstApi, secondApi])
      .then(
        axios.spread((res1, res2) => {
          let combinedData = [];
          let tem_isFemale = false;

          res1?.data?.data?.forEach((el) => {
            if (el?.gender?.toUpperCase() === 'FEMALE') {
              tem_isFemale = true;
            }
            combinedData.push(el);
          });

          res2?.data?.data?.forEach((el) => {
            combinedData.push(el);
          });
          combinedData?.sort(
            (a, b) => new Date(b.tripDate) - new Date(a.tripDate),
          );

          setIsFemale(tem_isFemale);
          setsosList(combinedData);
        }),
      )
      .catch((err) => {
        // Handle errors here
        console.error('Error fetching data: ', err);
      })
      .finally(() => {
        setSosLoading(false);
      });
  };
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'space-between',
        paddingRight: '18px',
        borderRight: '1px solid #dddddd',
      }}
    >
      {(user?.userList?.userRole == 'CORPORATEADMIN' ||
        user?.userList?.userRole == 'VENDOR') && (
        <>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              width: 300,
              height: 40,
              marginRight: '2px',
              fontSize: '12px',
              paddingRight: '18px',
              borderRight: '1px solid #dddddd',
              // backgroundColor: '#3498db',
              // borderRadius: '5px',
            }}
          >
            <span style={{padding: '3px'}}>
              <LocationOnIcon />
            </span>
            <div style={{flex: 1, padding: '3px'}}>
              {address?.location?.locName}
            </div>
          </div>
          <AppTooltip title='Active Trip' placement={tooltipPosition}>
            <IconButton
              className='icon-btn'
              sx={{
                borderRadius: '50%',
                width: 40,
                height: 40,
                marginLeft: 5,
                color: (theme) => theme.palette.text.secondary,
                backgroundColor: (theme) => theme.palette.background.default,
                border: 1,
                borderColor: 'transparent',
                '&:hover, &:focus': {
                  color: (theme) => theme.palette.text.primary,
                  backgroundColor: (theme) =>
                    alpha(theme.palette.background.default, 0.9),
                  borderColor: (theme) =>
                    alpha(theme.palette.text.secondary, 0.25),
                },
              }}
              onClick={() => {
                navigate('/onboard-corporate/livetrip');
              }}
              size='large'
            >
              <TimeToLeaveIcon />
            </IconButton>
          </AppTooltip>
        </>
      )}

      {(user?.userList?.userRole == 'CORPORATEADMIN' ||
        user?.userList?.userRole == 'VENDOR') && (
        <AppTooltip title='Live Tracking' placement={tooltipPosition}>
          <IconButton
            className='icon-btn'
            sx={{
              borderRadius: '50%',
              width: 40,
              height: 40,
              marginLeft: 5,
              color: (theme) => theme.palette.text.secondary,
              backgroundColor: (theme) => theme.palette.background.default,
              border: 1,
              borderColor: 'transparent',
              '&:hover, &:focus': {
                color: (theme) => theme.palette.text.primary,
                backgroundColor: (theme) =>
                  alpha(theme.palette.background.default, 0.9),
                borderColor: (theme) =>
                  alpha(theme.palette.text.secondary, 0.25),
              },
            }}
            onClick={() => {
              navigate('/live-tracking-dashboard/default');
            }}
            size='large'
          >
            <RoomIcon />
          </IconButton>
        </AppTooltip>
      )}
      {(user?.userList?.userRole == 'TANENTADMIN' ||
        (user?.userList?.userRole == 'SUPERADMIN' &&
          user?.userList?.isImpersonate == 'TANENT')) &&
        (corporateList?.length > 0 || user?.userList?.tanentId) && (
          <Autocomplete
            id='country-select-demo'
            sx={{width: '250px', marginRight: '15px'}}
            options={corporateList}
            value={corpVal}
            disableClearable
            limitTags={1}
            autoHighlight
            onChange={(e, v, r) => {
              setCorpVal(v);
              if (v && v.value) {
                saveNewCorp(v.value, v.imgsrc);
              }
            }}
            getOptionLabel={(option) => option.title}
            renderOption={(props, option, ind) => (
              <Box
                key={ind + '>>'}
                component='li'
                sx={{'& > img': {mr: 2, flexShrink: 0}}}
                {...props}
              >
                <img loading='lazy' width='20' src={option.imgsrc} alt='' />
                {option.title2}
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                style={{border: 'none'}}
                {...params}
                inputProps={{
                  ...params.inputProps,
                  autoComplete: 'off', // disable autocomplete and autofill
                }}
              />
            )}
          />
        )}
      <SOSPopup getSSOPassengers={getSSOPassengers} />
      {isMenu ? (
        <Box component='span'>Message</Box>
      ) : (
        <AppTooltip title='Notification' placement={tooltipPosition}>
          <IconButton
            className='icon-btn'
            sx={{
              borderRadius: '50%',
              width: 40,
              height: 40,
              marginLeft: 5,
              color: (theme) => theme.palette.text.secondary,
              backgroundColor: (theme) => theme.palette.background.default,
              border: 1,
              borderColor: 'transparent',
              '&:hover, &:focus': {
                color: (theme) => theme.palette.text.primary,
                backgroundColor: (theme) =>
                  alpha(theme.palette.background.default, 0.9),
                borderColor: (theme) =>
                  alpha(theme.palette.text.secondary, 0.25),
              },
            }}
            onClick={() => navigate('/notifications')}
            size='large'
          >
            <NotificationsNoneIcon />
          </IconButton>
        </AppTooltip>
      )}
      {/* This is notification drawer */}
      <Drawer
        anchor={drawerPosition}
        open={!!clickedSOS}
        onClose={() => {
          dispatch(sosClicked());
        }}
      >
        {sosLoading ? (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minWidth: 320,
              height: '100%',
              p: 4,
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <AppNotificationContent
            sxStyle={sxNotificationContentStyle}
            sosList={sosList}
            isFemale={isFemale}
            onClose={() => {
              dispatch(sosClicked());
            }}
          />
        )}
      </Drawer>
    </div>
  );
};

export default AppNotifications;

AppNotifications.defaultProps = {
  drawerPosition: 'right',
  tooltipPosition: 'bottom',
};

AppNotifications.propTypes = {
  drawerPosition: PropTypes.string,
  tooltipPosition: PropTypes.string,
  isMenu: PropTypes.bool,
  sxNotificationContentStyle: PropTypes.object,
};
